import React from "react";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import AppTable from "components/Shared/AppTable";

import { useListAccountAuthorizationQuery } from "store/services/authorizationApi";

const AccountLvlAuthorizationListScreen = () => {
  const breadcrumbs = [{ title: "Authorizations" }];

  // RTK Query
  const {
    data: accountLvlAuthorizations,
    isLoading: loadingAuthorizations,
    error,
  } = useListAccountAuthorizationQuery("Active");

  const columns = [
    {
      name: "Level",
      selector: (row) => row?.level ?? "N/A",
    },
    {
      name: "Type",
      selector: (row) => row?.type ?? "N/A",
    },
    {
      name: "Role",
      selector: (row) => row?.role ?? "N/A",
    },
  ];

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={loadingAuthorizations}>
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <AppTable
          columns={columns}
          data={accountLvlAuthorizations}
          progressPending={loadingAuthorizations}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default AccountLvlAuthorizationListScreen;
